import { ZONES_ACTIONS, initialZonesState } from './zones.types'

/**
 * @param {import('./zones.types').ZonesSlice} state
 * @param {Object} action
 */
export function zonesReducer(state = initialZonesState, { type, payload }) {
  switch (type) {
    case ZONES_ACTIONS.SET_ZONES:
      return { ...state, data: payload }

    case ZONES_ACTIONS.SET_ZONE:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case ZONES_ACTIONS.REMOVE_ZONE:
      const { [payload]: removedZone, ...remainingZones } = state.data
      return {
        ...state,
        data: remainingZones
      }

    case ZONES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case ZONES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case ZONES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
